<template>
  <div class="coursedetails">
    <!-- 视频 -->
    <div class="details_bgvd">
      <div class="details_warp">
        <div class="deta_bread">
          <div class="inner">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <!-- <el-breadcrumb-item>{{ professionName }}</el-breadcrumb-item> -->
              <el-breadcrumb-item>{{ courselist.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>

        <div class="course_details">
          <div class="inner">
            <div :class="[isShowLabel ? 'video_active' : '', 'video_center']">
              <!-- 视频 -->
              <div
                class="vidall"
                v-if="vidshow == false && endshow == false"
                :style="{
                  backgroundImage: 'url(' + courselist.cover + ')',
                  backgroundSize: 'cover',
                }"
              >
                <!-- 课程封面 -->
                <div class="vid_cover" @click="play">
                  <div class="playicon">
                    <i class="el-icon-video-play"></i>
                  </div>
                </div>
              </div>
              <!-- 试看两分钟结束后 -->
              <div
                class="endwarp"
                :style="{ backgroundImage: 'url(' + courselist.cover + ')' }"
                v-else-if="endshow == true"
              >
                <div class="endicon" v-if="tokens == undefined">
                  <div class="end_conts">
                    <p>试看结束</p>
                    <!-- <p>试看结束,立即预约观看完整版</p>
                    <el-button @click="makebtns" class="immediately" type="primary" round
                      >立即预约</el-button
                    > -->
                  </div>
                </div>
                <div v-else class="endicon" @click="shilooks">
                  <div class="end_conts">
                    <span style="color: #ffffff; font-size: 24px"
                      ><i class="el-icon-refresh-right"></i> 试看结束</span
                    >
                  </div>
                </div>
              </div>

              <!-- 视频播放 -->
              <video
                v-else
                controls
                disablePictureInPicture
                controlslist="nodownload  noremoteplayback noplaybackrate "
                :poster="courselist.cover"
                :src="vidurl"
                autoplay
                id="videos"
                ref="videomy"
                @timeupdate="timeupdate"
                @ended="endedac"
                @pause="vidpause"
                @play="vidplay"
                @waiting="waitvido"
                webkit-playsinline="true"
                playsinline="true"
                crossorigin="anonymous"
                style="background: #000"
              >
                您的浏览器不支持 HTML5 video 标签。
              </video>
              <!-- <div v-if="vidshow==true" @click="vidzhezhao" class="vidzhezhao"></div> -->
              <!-- 标题 -->
              <div class="vid_title">
                <div class="">
                  <span class="title_txts">{{ courselist.title }}</span>
                  <!-- <span class="curnums" v-show="courselist.classHours">{{ (courselist.classHours / 60 / 45).toFixed(2) }}学时</span> -->
                  <!-- 立即报名 -->
                  <div class="promptly_wap">
                    <div class="">
                      <span
                        v-if="tokens == undefined || tokens == null || tokens == ''"
                      ></span>
                      <el-button
                        class="promptly_btns"
                        type="warning"
                        v-else-if="enstatus == 0 && viewPermissions == 1"
                        throttleTime="500"
                        >报名审核中</el-button
                      >
                      <el-button
                        class="promptly_btns"
                        v-else-if="enstatus == 1 && viewPermissions == 1"
                        throttleTime="500"
                        type="success"
                        >报名通过</el-button
                      >
                      <div v-else>
                        <el-button
                          class="promptly_btns"
                          v-if="viewPermissions == 1"
                          @click="enlist"
                          throttleTime="500"
                          type="primary"
                          >立即报名</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="[isShowLabel ? 'label_all_active' : '', 'label_all']">
              <div class="title_nav">
                <div :class="{ title_nav_item: !titleNav }" @click="handleTitleNav(0)">
                  课程详情
                </div>
                <div :class="{ title_nav_item: titleNav }" @click="handleTitleNav(1)">
                  课程书签
                </div>
              </div>
              <div class="course_lists" v-show="!titleNav">
                <el-scrollbar style="height: 100%">
                  <div class="course_list_box">
                    <coursetree
                      ref="mtree"
                      :data="tree.chapterTree"
                      :currdata="currentChapterId"
                      :classStatus="classStatus"
                      @videoURL="videoURL"
                      @tkuangtimes="tkuangtimes"
                    ></coursetree>
                  </div>
                </el-scrollbar>
              </div>
              <div class="shuqian_list" v-show="titleNav">
                <div style="height: 100%" v-if="$store.getters.userId">
                  <div class="header">
                    <span class="line"></span>
                    <span class="teacherOrSelf">
                      <span
                        style="width: 40px; height: 20px; font-size: 14px"
                        :class="{ teacher_active: teacherActive }"
                        class="other teacher"
                        @click="handleOtherLabel(0)"
                        >老师</span
                      >
                      <span
                        style="width: 40px; height: 20px; font-size: 14px"
                        :class="{ self_active: selfActive }"
                        class="other self"
                        @click="handleOtherLabel(1)"
                        >我的</span
                      >
                    </span>
                  </div>
                  <div class="label_content">
                    <el-scrollbar style="height: 100%">
                      <div
                        class="label_title"
                        v-for="(item, index) in labelTree"
                        :key="item.chapterId"
                      >
                        <span class="label_header"
                          >第{{ index + 1 > 9 ? index + 1 : "0" + (index + 1) }}章
                          {{ item.label }}</span
                        >
                        <div
                          class="label_sub_title"
                          v-for="(childItem, childIndex) in item.children"
                          :key="childItem.chapterId"
                        >
                          <div class="label_header" @click="handleGainLabel(childItem)">
                            <span class="overflow_sellip"
                              >第{{
                                childIndex + 1 > 9
                                  ? childIndex + 1
                                  : "0" + (childIndex + 1)
                              }}节：{{ childItem.label }}</span
                            >
                            <span>
                              <span
                                v-if="childItem.loading"
                                class="el-icon-loading"
                              ></span>
                              <span
                                v-if="!childItem.isShow && !childItem.loading"
                                class="el-icon-arrow-down"
                              ></span>
                              <span
                                v-else-if="childItem.isShow && !childItem.loading"
                                class="el-icon-arrow-up"
                              ></span>
                            </span>
                          </div>
                          <template v-if="childItem.children">
                            <el-collapse-transition>
                              <div v-show="childItem.isShow">
                                <template v-for="labelItem in childItem.children">
                                  <div
                                    class="label_item"
                                    :key="labelItem.id"
                                    v-if="
                                      $store.getters.userId == labelItem.userId
                                        ? !selfActive
                                        : !teacherActive
                                    "
                                  >
                                    <div
                                      class="left"
                                      @click="
                                        handleLabelDetails(
                                          labelItem,
                                          childItem,
                                          index,
                                          childIndex
                                        )
                                      "
                                    >
                                      <span
                                        :class="[
                                          'left_teacher',
                                          $store.getters.userId == labelItem.userId
                                            ? 'left_self'
                                            : '',
                                        ]"
                                      ></span>
                                      <span class="icon"></span>
                                      <span
                                        class="txt overflow_sellip"
                                        :title="labelItem.labelInfo"
                                        >{{ labelItem.labelInfo }}</span
                                      >
                                    </div>
                                    <div class="right">
                                      <template
                                        v-if="
                                          isShowManage &&
                                          $store.getters.userId == labelItem.userId
                                        "
                                      >
                                        <span @click="updateLabel(labelItem)">修改</span>
                                        <span class="del" @click="deleteLabel(labelItem)"
                                          >删除</span
                                        >
                                      </template>
                                      <span v-else class="time">{{
                                        labelItem.labelTime | formateTime
                                      }}</span>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </el-collapse-transition>
                          </template>
                        </div>
                      </div>
                    </el-scrollbar>
                  </div>
                  <div class="label_super">添加课签</div>
                  <div class="label_super">课签详情</div>
                  <div class="btn_box">
                    <div class="operate_contenr">
                      <transition name="el-zoom-in-bottom">
                        <div v-show="isShowAddLable" class="operate_item add_label">
                          <div class="header">
                            {{ labelFrom.title }}
                            <el-button
                              type="text"
                              class="rt"
                              style="margin-right: -30px"
                              @click="closeAddLabel"
                            >
                              <i class="el-icon-close" style="font-size: 17px"></i>
                            </el-button>
                          </div>
                          <p class="pause_time" v-show="labelFrom.isAdd">
                            暂停位置：<span>{{ labelFrom.second | formateTime }}</span>
                          </p>
                          <p class="pause_time" v-show="!labelFrom.isAdd">
                            暂停位置：<span>{{
                              labelFrom.updateSecond | formateTime
                            }}</span>
                          </p>
                          <el-input
                            type="textarea"
                            :rows="8"
                            placeholder="请输入内容"
                            v-model="labelFrom.labelInfo"
                          >
                          </el-input>
                          <div class="footer">
                            <el-button
                              type="primary"
                              round
                              style="width: 130px"
                              size="small"
                              :loading="addLabelLoading"
                              @click="onSubmit"
                              >完 成</el-button
                            >
                          </div>
                        </div>
                      </transition>
                      <transition name="el-zoom-in-bottom">
                        <div
                          class="operate_item manage_label"
                          v-show="isShowLabelDetails"
                        >
                          <div class="header">
                            课签详情
                            <el-button
                              type="text"
                              class="rt"
                              style="margin-right: -30px"
                              @click="closeDetails"
                            >
                              <i class="el-icon-close" style="font-size: 17px"></i>
                            </el-button>
                          </div>
                          <div class="operate_detailed">
                            <p class="pause_time">
                              暂停位置：<span>{{
                                labelDetails.labelTime | formateTime
                              }}</span>
                            </p>
                            <p class="label_header">课签内容</p>
                            <p class="label_text">{{ labelDetails.labelInfo }}</p>
                            <p class="label_header">截图</p>
                            <el-image
                              style="width: 100%; height: 160px"
                              :src="labelDetails.screenshotUrl"
                              :preview-src-list="[labelDetails.screenshotUrl]"
                              fit="contain"
                            ></el-image>
                          </div>
                          <div class="footer">
                            <el-button
                              type="primary"
                              round
                              style="width: 130px"
                              size="small"
                              @click="onJumpNow(labelDetails)"
                              >立即跳转</el-button
                            >
                          </div>
                        </div>
                      </transition>
                    </div>
                    <a class="btn" href="javascript:;" @click="addLabel">添加课签</a>
                    <a class="btn" href="javascript:;" @click="mangaeLabel">管理课签</a>
                  </div>
                </div>
                <div v-else class="loginLabeltxt">
                  <div @click="handleLogin">请先登录</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div :class="[isShowLabel?'label_active':'','label_box']" @click="handleLabelClick">
            <span class="label"></span>
            课签
          </div> -->
        </div>
      </div>
    </div>
    <!-- 二维码弹出框 -->
    <el-dialog
      title="请用技能河南APP扫码进行人脸验证"
      :visible.sync="dialogVib"
      width="400px"
      :before-close="handleClose"
      :show-close="false"
      center
    >
      <div class="img_code">
        <div class="zhezhao_code"></div>
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="digdels">取消</el-button>
       
      </span> -->
    </el-dialog>
    <!-- 预约弹出框 -->
    <Makediglogs :dialoglogin="dialoglogin" @makelogs="makelogs"></Makediglogs>
    <!-- 试题弹出框 -->
    <el-dialog
      title="闯关测试"
      :visible.sync="examshow"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
      center
    >
      <div class="examwarp">
        <!-- 标题 -->
        <subject-title
          :quType="subjectObj.quType"
          :title="subjectObj.content"
        ></subject-title>
        <!-- 图片题 -->
        <subject-image
          v-if="subjectObj.fileType == 1"
          :url="subjectObj.fileUrl"
        ></subject-image>
        <!-- 视频 -->
        <subject-video
          v-if="subjectObj.fileType == 2"
          :url="subjectObj.fileUrl"
        ></subject-video>
        <!-- 单选项 -->
        <subject-options
          v-show="subjectLoading && (subjectObj.quType == 1 || subjectObj.quType == 3)"
          :options="dataOptions"
          :answer="answer"
          :qu-type="subjectObj.quType"
          :youAnswer="myAnswer"
          @setAnswer="getAnswer"
          :is-click="isClick"
        ></subject-options>
        <!-- 多选 -->
        <subject-many-search
          ref="manySearch"
          v-show="subjectLoading && subjectObj.quType == 2"
          :options="dataOptions"
          :answer="answer"
          :youAnswer="myAnswer"
          :is-click="isClick"
          @setManyClick="getAnswer"
        ></subject-many-search>
        <!-- 答案展示 -->
        <subject-answer
          v-show="!isClick"
          :answer="answer"
          :youAnswer="myAnswer"
          :is-right="isRight"
          :content="subjectObj.subjectObj"
        ></subject-answer>
      </div>
    </el-dialog>
    <!-- 介绍目录 -->
    <div class="courwarp">
      <div class="inner">
        <div class="courcenter">
          <!-- 左侧 -->
          <div class="couret_left">
            <!-- 头部 -->
            <div class="couret_heder">
              <div style="margin-top: 14px" class="courheder_child">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="课程介绍" name="first">
                    <div class="cur_jieshao">
                      <p v-html="courselist.description"></p>
                      <p style="margin-top: 10px" v-html="courselist.courseContent"></p>
                    </div>
                  </el-tab-pane>
                  <!-- 学习总进度 -->
                  <!-- <el-tab-pane label="课程目录" name="second">
                    <div class="pane_tree">
                      <p>学习总进度: {{tree.totalCompletion}}%</p> 
                      <el-progress  :percentage="tree.totalCompletion" color="#3964E6"></el-progress>
                    </div>
                  </el-tab-pane> -->
                  <el-tab-pane label="课程评论" name="third">
                    <div class="interactions">
                      <Interaction
                        :comment="comment"
                        :inparameter="inparameter"
                        @detals="detals"
                      ></Interaction>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
          <!-- 右侧 -->
          <div class="couret_right">
            <div class="tuijian_title">相关推荐</div>
            <div class="recommend_list">
              <template v-if="recommendList.length > 0">
                <div
                  class="recommend_item"
                  v-for="(item, index) in recommendList"
                  :key="index"
                  @click="handlePath(item)"
                >
                  <div class="img_box">
                    <el-image
                      style="
                        width: 100%;
                        height: 100%;
                        display: block;
                        background: #292929;
                      "
                      :src="item.cover || defaultImg"
                      fit="fill"
                      lazy
                    ></el-image>
                  </div>
                  <div class="right_text">
                    <h3 class="recommend_title overflow_sellip">{{ item.title }}</h3>
                    <p class="recommend_synop">{{ item.description }}</p>
                  </div>
                </div>
              </template>
              <div v-else class="unllTyoe">暂无相关推荐</div>
            </div>
          </div>
          <!-- 视频截帧所用的canvas -->
          <canvas v-show="false" id="myCanvas" width="343" height="200"></canvas>
          <!-- <div class="couret_rig">
        
            <div class="couret_heder_rig">
              <p>主讲老师</p>
            </div>
  
            <div class="teach_detail">
              <div class="teach_avimg">
                <el-image
                  style="width: 100%; height: 100%; border-radius: 50%"
                  :src="courselist.trainingLecturer.teacherPic"
                  fit="fill"
                ></el-image>
              </div>
        
              <div class="teach_names">
                <p>
                  {{ courselist.trainingLecturer.teacherTitle }} —
                  {{ courselist.trainingLecturer.teacherName }}
                </p>
              </div>
              <div class="tech_contxts">
                <p>{{ courselist.trainingLecturer.teacherContent }}</p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 二维码生成
import QRCode from "qrcodejs2";
import {
  coursedetails,
  chapterStudyRecord,
  getPlayUrlByChapterId,
  studyRecord,
  lastRecord,
  enlisup,
  uncertainEdlist,
  examget,
  examdetailget,
  getcomment,
  tankhisry,
  QRcode,
  qrcoderes,
  tanktimes,
  // 是否开启各种判断
  otherFunction,
  // 获取标签列表
  getLabelList,
  // 提交视频图片
  getScreenshot,
  // 添加标签
  addmark,
  // 修改课签
  updatemark,
  // 删除
  delProfession,
  kqpostimg,
} from "@/api/coursedetails";
import { getWebListCourse } from "@/api/home";
import coursetree from "@/components/courseTree/index.vue";
import { getToken } from "../utils/auth.js";
// 试题组件
import subjectSlide from "@/components/subject-slide/index.vue";
import subjectTitle from "@/components/subject-title/index.vue";
import subjectImage from "@/components/subject-image/index.vue";
import subjectVideo from "@/components/subject-video/subject-video.vue";
import subjectOptions from "@/components/subject-options/index.vue";
import subjectManySearch from "@/components/subject-many-search/index.vue";
import subjectAnswer from "@/components/subject-answer/index.vue";
// 评论互动
import Interaction from "@/components/interaction/interaction.vue";
import Makediglogs from "@/components/makedialog/makedialog.vue";
export default {
  name: "coursedetails",
  data() {
    return {
      courseControl: {
        functionQuBulletFrame: true, //是否开始课程学习弹出框
        functionCommonBulletFrame: false, // 观看视频中出现普通弹出框
        functionFaceRecognition: false, // 学习中刷脸
        functionChapterFaceRecognition: false, //点击下一章是是否进行人脸识别
        functionLoginFaceRecognition: false, //首次登陆刷脸功能（pc端没初次登陆完善个人信息人脸识别）
        functionScrollBar: false, //进度条拖拽
      },
      courselist: {
        title: "",
        id: "",
        description: "",
        courseContent: "",
        trainingLecturer: { teacherPic: "" },
      },
      tokens: getToken(),
      activeName: "first",
      courseId: "", //课程ID
      tree: {
        chapterTree: [],
      }, //课程目录
      userId: this.$store.getters.userId, //用户ID
      vidurl: "", //视频地址
      currentChapterId: "", //当前章节ID
      inparameter: {
        traineeId:
          this.$store.getters.userId == undefined ? "" : this.$store.getters.userId,
        chapterId: null, //章节ID
        courseId: null, //课程ID
        pageSize: 5,
        pageNum: 1,
      }, //评论组件所需参数
      completed: false,
      videoLocation: "",
      random: 0,
      examlist: [],
      classStatus: null, //课程是否开始 0未开始 1已开始 2已结束
      classStatustwo: null,
      enstatus: null, //是否报名
      cournameall: {
        title: "",
        beginTime: "",
        endTime: "",
      }, //开班时间和课程名称
      comment: { rows: [] }, //评论数据
      professionName: "", //分类
      vidshow: false,
      endshow: false,
      dialogVib: false, //弹出框
      qrcoderes: "", //qrId
      prcodestatus: false, //二维码扫码状态
      currentTime: "",
      durationall: "",
      video_real_time: 0, //实时播放进度
      freed_time: 60, //弹出管控
      bfacephtot: 0,
      examlist: [],
      amodeal: 0,
      // ----试题参数----
      examshow: false, //试题弹出框
      examlist: [], //试题列表
      subjectObj: {
        content: "",
        fileType: "",
        fileUrl: "",
        quType: "",
        isCollection: 0,
        id: "",
      }, // 试题主要内容
      subjectLoading: false, // 加载是隐藏
      // 选项列表
      dataOptions: [],
      // 答案
      answer: [],
      // 我的答案
      myAnswer: [],
      // 是否可被点击
      isClick: true,
      // 是否为正确的答案
      isRight: true,
      dialoglogin: false,
      tktimedata: {},
      videoLocation: 0,
      prcodetime: null,
      timsa: 0,
      loadingwarp: null, //全局的Loding
      zhezvd: false,
      // 是否显示课签
      isShowLabel: true,
      // 是否隐藏老师或学生课签
      teacherActive: false,
      selfActive: false,
      labelFrom: {
        second: 0,
        labelInfo: "",
        screenshotUrl: "",
        updateSecond: 0,
        isAdd: true,
        title: "添加课签",
      },
      uplateLabelForm: {},
      // 显示添加/修改课程
      isShowAddLable: false,
      // 显示隐藏 课签详情
      isShowLabelDetails: false,
      // 课签树形列表
      labelTree: [],
      // 添加标签loading
      addLabelLoading: false,
      // 是否显示删除/修改
      isShowManage: false,
      // 显示详情
      labelDetails: {},
      // 点击课签所属的章节
      chapterItem: {},
      // 课签对应的章index
      chapterIndex: null,
      // 课签对应的节index
      sectionIndex: null,
      histysetnum: 0,
      viewPermissions: null, //0 公开 1 报名 2 内部
      playsetms: null, //记录播放视频的定时器
      countdown: 0, //倒计时
      lookOver: false,
      imgSrcop: null, //视频截帧的文件流
      titleNav: 0,
      // 相关推荐列表
      recommendList: [],
      // 推荐默认预览图片
      defaultImg: require("@/assets/images/cursorDefault.png"),
    };
  },
  filters: {
    formateTime(time) {
      const h = parseInt(time / 3600);
      const minute = parseInt((time / 60) % 60);
      const second = Math.ceil(time % 60);

      const hours = h < 10 ? "0" + h : h;
      const formatSecond = second > 59 ? 59 : second;
      return `${hours > 0 ? `${hours}时` : ""}${minute < 10 ? "0" + minute : minute}分${
        formatSecond < 10 ? "0" + formatSecond : formatSecond
      }秒`;
    },
  },
  components: {
    coursetree,
    Interaction,
    // --试题组件--
    subjectTitle,
    subjectSlide,
    subjectImage,
    subjectVideo,
    subjectOptions,
    subjectManySearch,
    subjectAnswer,
    Makediglogs,
  },
  created() {
    this.$store.commit("user/SET_TABINDEX", 1030);
  },
  async mounted() {
    var res = await otherFunction();
    var data = res.data;
    var keys = Object.keys(data);
    keys.forEach((v) => {
      if (data[v] == "false") {
        data[v] = false;
      } else {
        data[v] = true;
      }
    });
    this.courseControl = data;
    this.courseId = this.$route.query.id;
    this.inparameter.courseId = this.$route.query.id;
    this.professionName = this.$route.query.professionName;
    //课程详情
    this.coursedet(this.courseId);
    //课程目录
    this.catalogue(this.courseId);
    //试看
    if (this.tokens == "" || this.tokens == undefined) {
      this.$message({
        message: "未登陆,可试看两分钟",
        type: "warning",
        offset: 150,
      });
    } else {
      //查询是否报名
      this.bolEnliststatus();
    }

    //使用
    let _this = this;
    window.onresize = function () {
      _this.zhezvd = _this.checkFullScreen();
      if (_this.zhezvd) {
        console.log("全屏状态");
      } else {
        console.log("缩小状态");
      }
    };
    if (this.$route.query.professionId) {
      this.getWebListCourse({ professionId: this.$route.query.professionId });
    }
  },
  beforeDestroy() {
    //销毁定时器
    clearInterval(this.playsetms);
    this.playsetms = null;
  },
  //
  methods: {
    // 课程详情
    coursedet(id) {
      this.loadingwarp = this.$loading({
        lock: true,
        text: "努力加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      coursedetails(id).then((res) => {
        if (res.code == 200) {
          this.courselist = res.data;
          this.viewPermissions = Number(res.data.viewPermissions);
          if (res.data.courseContent == null || res.data.courseContent == "") {
            // console.log("详情内容为空");
          } else {
            this.courselist.courseContent = res.data.courseContent
              .replace(/\/prod-api/g, process.env.VUE_APP_BASE_API)
              .replace(/\<img/g, "<img style='width: 100%;'");
          }
        }
      });
    },
    // 课程目录
    catalogue(id) {
      let datas;
      if (this.tokens == "" || this.tokens == undefined) {
        datas = {
          courseId: id,
        };
      } else {
        datas = {
          traineeId: this.userId,
          courseId: id,
        };
      }

      chapterStudyRecord(datas).then((res) => {
        if (res.code == 200 && res.data.chapterTree.length > 0) {
          res.data.chapterTree.forEach((value, index) => {
            value["childrenshow"] = true;
          });
          let datfilter = res.data.chapterTree;
          this.tree = res.data;
          this.labelTree = JSON.parse(JSON.stringify(datfilter)).map((v) => {
            if (v.children) {
              return {
                ...v,
                children: v.children.map((i) => {
                  return { ...i, isShow: false, isRequest: true, loading: false };
                }),
              };
            } else {
              return v;
            }
          });
          let chapall = [];
          let currentCourse = [];
          if (datfilter) {
            var stlo = datfilter.filter((item) => {
              if (item.children) {
                item.children.filter((itemchil) => {
                  if (itemchil.completion < 100) {
                    chapall.push(itemchil.chapterId);
                    currentCourse.push(itemchil);
                  }
                });
              }
            });
            if (this.$route.query.chapterId) {
              this.videoIdUrl(this.$route.query.chapterId);
            } else if (chapall.length == 0) {
              this.videoIdUrl(res.data.chapterTree[0].children[0].chapterId);
            } else {
              this.videoIdUrl(chapall[0]);
            }
          }
          //展开当前学习章节的书签列表
          // let bookdata = {
          //   ...currentCourse[0],
          //   isShow: false,
          //   isRequest: true,
          //   loading: false,
          // };
          // for (let index = 0; index < this.labelTree.length; index++) {
          //   const labelItem = this.labelTree[index];
          //   if (labelItem.children.length > 0) {
          //     for (let index2 = 0; index2 < labelItem.children.length; index2++) {
          //       const childItems = labelItem.children[index2];
          //       if (childItems.chapterId == bookdata.chapterId) {
          //         this.labelTree[index].children[index2] = bookdata;
          //       }
          //     }
          //   }
          // }

          // this.handleGainLabel(bookdata);
        }
      });
    },
    openBookdata(chapterId) {
      var bookdata;
      for (let index = 0; index < this.labelTree.length; index++) {
        const labelItem = this.labelTree[index];
        if (labelItem.children&&labelItem.children.length > 0) {
          for (let index2 = 0; index2 < labelItem.children.length; index2++) {
            const childItems = labelItem.children[index2];
            if (childItems.chapterId == chapterId) {
              //展开当前学习章节的书签列表
              bookdata = {
                ...childItems,
                isShow: false,
                isRequest: true,
                loading: false,
              };
              this.labelTree[index].children[index2] = bookdata;
            }
          }
        }
      }
      this.handleGainLabel(bookdata);
    },
    //根据章节ID获取视频资源URL
    videoIdUrl(chapterId) {
      this.currentChapterId = chapterId;
      this.inparameter.chapterId = this.currentChapterId;
      // 评论数据
      this.detals(this.inparameter);
      //课签数据并打开
      this.openBookdata(chapterId);
      getPlayUrlByChapterId({ chapterId: chapterId }).then((res) => {
        if (res.code == 200) {
          this.vidurl = res.data;
          if (this.tokens == "" || this.tokens == undefined) {
          } else {
            this.playtime(chapterId);
          }
        }
        //关闭Loading
        this.loadingwarp.close();
      });
    },
    cataloguetwo(id) {
      //观看完不再调用接口更新进度
      if (this.lookOver == true) {
        return;
      }
      let datas;
      if (this.tokens == "" || this.tokens == undefined) {
        datas = {
          courseId: id,
        };
      } else {
        datas = {
          traineeId: this.$store.state.user.profile.id + "",
          courseId: id,
        };
      }
      chapterStudyRecord(datas).then((res) => {
        if (res.code == 200 && res.data.chapterTree.length > 0) {
          res.data.chapterTree.forEach((value, index) => {
            value["childrenshow"] = true;
          });
          this.tree = res.data;
        }
      });
    },
    // 查询播放记录
    playtime(chapterId) {
      lastRecord({ chapterId: chapterId }).then((res) => {
        if (res.data) {
          //是否观看完
          this.completed = res.data.completed;
          this.lookOver = res.data.completed;
          this.videoLocation = res.data.recordLocation;
          this.random = 0;

          if (res.data.completed == false) {
            //弹框位置
            this.tkuangtimes(chapterId);
            if (this.$refs.videomy) {
              this.$nextTick(() => {
                this.$refs.videomy.currentTime = this.videoLocation;
              });
            }
          }
        } else {
          //弹框位置
          this.tkuangtimes(chapterId);
        }
      });
    },
    // 60秒记录一次播放
    setInhistory() {
      if (!this.tokens) {
        return;
      }
      //定时器
      let _this = this;
      clearInterval(_this.playsetms);
      _this.playsetms = setInterval(() => {
        _this.countdown++;
        console.log(_this.countdown);
        if (_this.countdown == 60) {
          _this.historyTime();
        }
      }, 1000);
    },
    // 记录播放位置---未学习
    historyTime() {
      this.histysetnum = 0;
      if (this.currentTime == "" || this.currentTime < 0) {
        return;
      }
      let datas = {
        courseId: this.courseId, //课程ID
        chapterId: this.currentChapterId, //章节ID
        completed: this.completed, //是否完成学习
        recordLocation: this.currentTime, //播放位置
        studyTime: this.countdown,
      };
      studyRecord(datas)
        .then((res) => {
          if (res.code == 200) {
            if (this.completed == false && this.currentTime > 1) {
              this.videoLocation = this.currentTime;
            }
            //进度更新
            this.cataloguetwo(this.courseId);
            this.countdown = 0;
          }
        })
        .catch((err) => {});
    },
    //视频缓冲时触发
    waitvido(e) {
      //销毁定时器
      clearInterval(this.playsetms);
      this.playsetms = null;
      this.random = 0;
    },
    // 视频播放完成后触发
    endedac() {
      //进度
      let speeds = Math.ceil((this.currentTime / Math.floor(this.durationall)) * 100);

      if (speeds >= 95 && this.completed == false) {
        this.completed = true;
        this.historyTime();
      }
    },
    // 3种弹框的播放位置
    tkuangtimes(chapterId) {
      tanktimes({ chapterId: chapterId }).then((res) => {
        if (res.code == 200) {
          this.tktimedata = res.data;
        } else {
        }
      });
    },
    // 退出全屏
    exitfull() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }

      if (typeof request_full_screen != "undefined" && request_full_screen) {
        request_full_screen.call(el);
      }
    },
    // 播放进度变化
    timeupdate(e) {
      this.currentTime = parseInt(e.target.currentTime);
      this.labelFrom.second = this.currentTime;

      if (this.playsetms == null) {
        this.random++;
        if (this.random == 2) {
          this.setInhistory();
        }
      }
      // 禁止拖动进度条处理
      var isReady = 1; // 是否开启可以视频快进 1 禁止开启
      let that = this;
      //播放的总时长
      var duration = e.target.duration;
      //  未报名或者未开班 试看两分钟&&!that.tokens
      if (!that.tokens && that.currentTime >= 120) {
        if (that.zhezvd == true) {
          that.exitfull();
        }
        that.vidshow = false;
        that.endshow = true;

        return;
      }
      if (that.enstatus !== 1 && that.currentTime >= 120 && that.viewPermissions == 1) {
        if (that.zhezvd == true) {
          that.exitfull();
        }
        that.vidshow = false;
        that.endshow = true;

        return;
      }
      //当前视频进度
      // console.log('视频播放到第' + that.currentTime + '秒');
      // console.log('当前播放位置' + that.videoLocation + '秒');

      if (that.video_real_time == 0) {
        var jump_time = parseInt(that.videoLocation) + parseInt(that.video_real_time);
      } else {
        var jump_time = parseInt(that.video_real_time);
      }

      if (isReady == 1) {
        if (
          that.currentTime > jump_time &&
          that.currentTime - jump_time > 1 &&
          !that.courseControl.functionScrollBar
        ) {
          this.$refs.videomy.currentTime = that.video_real_time;
          that.currentTime = that.video_real_time;
          return;
        }
        // if (
        //   that.currentTime > jump_time &&
        //   that.currentTime - jump_time > 1 &&
        //   that.currentTime > that.videoLocation &&
        //   that.completed == false
        // ) {
        //   this.$refs.videomy.currentTime = that.video_real_time;
        //   that.currentTime = that.video_real_time;
        //   this.$message({
        //     message: "不可快进",
        //     type: "error",
        //   });
        //   return;
        // }
        that.video_real_time = that.currentTime; //实时播放进度
        if (
          that.tokens == undefined ||
          that.classStatus !== 1 ||
          that.enstatus !== 1 ||
          that.completed == true ||
          that.currentTime <= that.videoLocation
        ) {
          // console.log("不管制");
          return;
        }
        that.endedac();
        var currtm = "d" + that.currentTime;
        if (that.tktimedata[currtm]) {
          //1 人脸 2普通弹框3试题
          switch (that.tktimedata[currtm].type) {
            case 1:
              if (this.courseControl.functionFaceRecognition) {
                that.bfacephtot++;
                if (that.bfacephtot == 4) {
                  that.randnums++; //抓拍次数
                  that.videoLocation = that.currentTime;
                  if (that.zhezvd == true) {
                    that.exitfull();
                  }

                  that.$refs.videomy.pause();
                  that.getqucode(that.currentChapterId);
                }
              }
              break;
            case 2:
              if (this.courseControl.functionCommonBulletFrame) {
                that.amodeal++;
                if (that.amodeal == 4) {
                  if (that.zhezvd == true) {
                    that.exitfull();
                  }
                  that.$refs.videomy.pause();
                  this.$confirm("请点击确定继续观看课程, 是否继续?", "弹框管控提醒", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    showClose: false,
                    closeOnClickModal: false,
                  })
                    .then(() => {
                      that.$refs.videomy.play();
                      that.amodeal = 0;
                      that.tanrecord(2, "");
                      //记录播放位置
                      that.historyTime();
                    })
                    .catch(() => {
                      this.$router.push({ path: "/" });
                    });
                }
              }
              break;
            case 3:
              if (this.courseControl.functionQuBulletFrame) {
                that.amodeal++;
                if (that.amodeal == 4) {
                  that.examdetails(that.tktimedata[currtm].obj.quId);
                  if (that.zhezvd == true) {
                    that.exitfull();
                  }
                  that.$refs.videomy.pause();
                  that.myAnswer = [];
                  that.examshow = true;
                  that.zhezhaoshow = true;
                }
              }
              break;
            default:
              break;
          }
        }
      }
    },
    // 视频暂停事件
    vidpause(e) {
      //销毁定时器
      clearInterval(this.playsetms);
      this.playsetms = null;
      this.random = 0;
      this.labelFrom.second = parseInt(e.target.currentTime);
    },
    //视频播放事件
    vidplay(e) {
      //记录
      this.setInhistory();
    },
    // 登陆后的试看
    shilooks() {
      this.endshow = false;
      this.vidshow = true;
    },
    //报名
    enlist() {
      //查询是否完善信息
      if (this.pfactinfo() == false) {
        return;
      }
      let datas = {
        traineeId: this.userId,
        courseId: this.courseId,
      };

      enlisup(datas).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "报名成功",
            type: "success",
          });
          this.enliststatus(this.courseId);
        }
      });
    },
    //查询是否完善信息
    pfactinfo() {
      //手机号  身份证正反面 人脸
      let userall = this.$store.state.user.profile;
      if (
        (userall.idPicFront == null ||
          userall.idPicFront == "" ||
          userall.idPicBack == null ||
          userall.idPicBack == "" ||
          userall.facePic == null ||
          userall.facePic == "") &&
        this.courseControl.functionLoginFaceRecognition
      ) {
        this.$message({
          message: "请先下载技能河南APP完善个人信息",
          type: "error",
        });
        return false;
      }
    },
    // 查询是否报名
    bolEnliststatus() {
      if (
        this.$store.getters.courseId !== null &&
        this.$store.getters.courseId !== Number(this.courseId)
      ) {
        this.enliststatustwo(this.$store.getters.courseId);
      } else {
        this.enliststatus(this.courseId);
      }
    },
    // 查询是否报名
    enliststatus(courId) {
      uncertainEdlist({ courseId: courId }).then((res) => {
        if (res.data) {
          this.enstatus = res.data.status;
          this.classStatus = res.data.classStatus;
          if (res.data.trainingClass) {
            this.cournameall = res.data.trainingClass;
          }
          // console.log(this.cournameall, "当前课程1");
        }
      });
    },
    // info中的课程IDcurrentCourseId
    //如果已经学了课程，但是和当前的课程不相等。
    //那么需要查询下学的课程班级是不是已经结束，如果结束了，那么就可以报名
    enliststatustwo(currentCourseId) {
      uncertainEdlist({ courseId: currentCourseId }).then((res) => {
        if (res.data) {
          this.enstatustwo = res.data.status;
          this.classStatustwo = res.data.classStatus;
          if (this.classStatustwo == 2) {
            this.enliststatus(this.courseId);
          }
          // console.log("当前课程2");
        }
      });
    },
    // 子传父
    videoURL(e) {
      this.vidurl = e.urlvid;
      this.vidtit = e.label;
      this.completed = e.completed;
      this.lookOver = e.completed;

      //当前章节的ID
      this.currentChapterId = e.chapterId;
      this.currentTime = e.recordLocation;
      this.videoLocation = e.recordLocation;
      this.video_real_time = e.recordLocation;
      this.inparameter.chapterId = this.currentChapterId;
      // 评论数据
      this.detals(this.inparameter);
      this.openBookdata(this.currentChapterId);
      //课签数据并打开
      if (this.tokens == "" || this.tokens == undefined) {
      } else {
        this.playtime(e.chapterId);
      }
      // console.log(this.currentTime,'currentTime')
      //查询播放记录
      if (e.completed == true && !this.courseControl.functionChapterFaceRecognition) {
        this.vidshow = true;
        this.$nextTick(() => {
          // 播放
          this.$refs.videomy.play();
        });
      } else {
        this.vidshow = false;

        this.play();
      }
    },
    //评论数据
    detals(data) {
      getcomment(data).then((res) => {
        if (res.code == 200) {
          this.comment = res;
        }
      });
    },

    // tab切换
    handleClick(tab, event) {},
    // 播放
    play() {
      if (this.vidurl == "") {
        this.$message({
          message: "暂时没有课程资源",
          type: "error",
        });
      } else {
        //登录 + 报名审核通过+配置是否人脸识别
        if (
          this.tokens &&
          this.enstatus == 1 &&
          this.courseControl.functionChapterFaceRecognition
        ) {
          //人脸识别的二维码
          this.getqucode(this.currentChapterId);
        } else {
          // 直接看
          this.vidshow = true;
          //续播
          this.$nextTick(() => {
            this.$refs.videomy.play();
            this.$refs.videomy.currentTime = this.videoLocation;
            //记录
            this.setInhistory();
          });
          // console.log("播放C");
        }
      }
    },
    // 请求二维码
    getqucode(chapterId) {
      QRcode({ chapterId: chapterId }).then((res) => {
        if (res.code == 200) {
          this.qrcoderes = res.data;
          this.creatQrCode(res.data);
        }
      });
    },
    handleClose(done) {},
    // 生成二维码
    creatQrCode(data) {
      this.dialogVib = true;
      let lodtimes = {
        videoLocation: this.videoLocation,
      };
      let codedata = { ...this.inparameter, ...data, ...lodtimes };
      // console.log(codedata, "po");
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = ""; //清除二维码方法一
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: JSON.stringify(codedata), // 需要转换为二维码的内容
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcoderesall(codedata.chapterId, codedata.qrId);
      });
    },
    //二维码扫描结果
    qrcoderesall(chapterId, qrId) {
      var datas = {
        chapterId: chapterId,
        qrid: qrId,
      };
      qrcoderes(datas).then((res) => {
        if (res.code == 200) {
          this.prcodestatus = res.data;
          if (this.prcodestatus == true) {
            clearTimeout(this.prcodetime);

            this.$message({
              message: "人脸识别验证成功,欢迎来到技能河南学习!!!",
              type: "success",
              offset: 150,
            });
            this.dialogVib = false;
            this.vidshow = true;
            if (this.vidshow == true) {
              //记录播放位置
              this.historyTime();
              this.$nextTick(() => {
                this.$refs.videomy.play();
                this.$refs.videomy.currentTime = this.videoLocation;
              });
            }
          } else {
            //false继续轮询
            if (this.dialogVib == true) {
              clearTimeout(this.prcodetime);
              // console.log(datas, "结果");

              this.prcodetime = setTimeout(() => {
                this.timsa += 3;
                this.qrcoderesall(datas.chapterId, datas.qrid);
              }, 3000);
              if (this.timsa > 90) {
                // console.log(this.timsa,"a")
                this.timsa = 0;
                this.getqucode(this.currentChapterId);
              }
            } else {
              clearTimeout(this.prcodetime);
            }
          }
        } else {
        }
      });
    },
    // 取消
    digdels() {
      let _this = this;
      this.$confirm("关闭人脸验证将返回首页, 是否继续?", "关闭提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        closeOnClickModal: false,
      })
        .then(() => {
          _this.dialogVib = false;
          _this.$router.push({ path: "/" });
          clearTimeout(this.prcodetime);
          clearTimeout(this.qicodetimes);
        })
        .catch(() => {});
    },
    // 确定
    digqued() {
      this.dialogVib = false;
    },
    // 弹框记录
    tanrecord(type, otherId) {
      if (this.tokens == undefined) {
        return;
      }
      let datas = {
        traineeId: this.userId,
        courseId: this.courseId,
        chapterId: this.currentChapterId,
        playLocation: this.currentTime,
        type: type,
        otherId: otherId,
        result: 1,
      };
      tankhisry(datas).then((res) => {});
    },
    //试题详情
    examdetails(quId) {
      this.otherId = quId;
      examdetailget({ paperType: 1, quIds: quId })
        .then((res) => {
          const options = [];
          const answer = [];
          const {
            answerList,
            content,
            fileType,
            fileUrl,
            quType,
            isCollection,
            id,
            analysis,
          } = res.data[0];
          this.examsloading = false;
          this.subjectObj = {
            content,
            fileType,
            fileUrl,
            quType,
            isCollection,
            id,
            analysis,
          };
          answerList.forEach((v, i) => {
            options.push({
              id: v.id,
              txt: v.content,
              isAnswer: 1,
            });
            if (v.isRight) {
              answer.push(i);
            }
          });
          this.answer = answer;
          this.dataOptions = options;
          var quIdIndex = this.mySequentialPractice[id];

          if (this.title == "背题练习") {
            this.myAnswer = answer;
            this.isClick = false;
            this.isRight = true;
          } else {
            if (quIdIndex) {
              this.isClick = false;
              this.myAnswer = quIdIndex.myAnswer;
              this.isRight = quIdIndex.isFlag;
            } else {
              this.isClick = true;
              this.myAnswer = [];
            }
          }
          this.subjectLoading = true;
        })
        .catch((err) => {
          this.subjectLoading = true;
        });
    },
    getAnswer(data) {
      var yesAll = 0;
      var wrongAll = 0;
      var sationObj = {};
      var timerset;
      this.myAnswer = data.myAnswer;
      this.isRight = data.isFlag;
      this.isClick = true;
      this.$refs.videomy.play();

      this.tkuangtimes(this.currentChapterId);
      //记录播放位置
      this.historyTime();
      //试题弹框记录
      if (this.otherId == "" || this.otherId == null) {
      } else {
        this.tanrecord(3, this.otherId);
      }
      //关闭题目弹出框
      this.examshow = false;
      this.zhezhaoshow = false;
      this.dataOptions = [];
      this.myAnswer = [];
      this.answer = [];
      this.subjectObj = {};
      this.amodeal = 0;
    },
    // 未登录试看结束后的立即预约按钮
    makebtns() {
      this.dialoglogin = true;
    },
    makelogs(e) {
      this.dialoglogin = e;
    },
    vidzhezhao() {
      this.zhezvd = !this.zhezvd;
      this.$nextTick(() => {
        if (this.zhezvd == true) {
          this.$refs.videomy.pause();
        } else {
          this.$refs.videomy.play();
        }
      });
      // console.log("遮罩")
    },
    // 判断是否在全屏
    checkFullScreen() {
      var isFull =
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement ||
        document.fullscreenElement;
      if (isFull == null || isFull == undefined) {
        isFull = false;
      }
      // console.log(isFull,'isFull')
      return isFull;
    },
    // 课签是否显示
    handleLabelClick() {
      this.isShowLabel = !this.isShowLabel;
    },
    // 个人和老师课签的筛选
    handleOtherLabel(i) {
      if (i) {
        //学生
        this.selfActive = !this.selfActive;
      } else {
        //老师
        this.teacherActive = !this.teacherActive;
      }
    },
    // 修改课签
    updateLabel(item) {
      this.openAddLabel();
      this.labelFrom.title = "修改课签";
      this.labelFrom.isAdd = false;
      this.labelFrom.labelInfo = item.labelInfo;
      this.labelFrom.updateSecond = item.labelTime;
      this.uplateLabelForm = item;
    },
    // 删除课签
    deleteLabel(item) {
      const ids = item.id;
      this.$confirm('是否确认删除编号为"' + ids + '"的数据项？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delProfession(ids).then((res) => {
            this.labelTree.forEach((v) => {
              if (v.children) {
                v.children.forEach((i) => {
                  if (i.chapterId == item.chapterId) {
                    getLabelList({
                      userId: this.$store.getters.userId,
                      chapterId: i.chapterId,
                    }).then((res) => {
                      i.children = res.rows;
                    });
                  }
                });
              }
            });
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 添加课签
    addLabel() {
      if (this.vidshow) {
        this.openAddLabel();
        this.cutPicture();
      } else {
        this.$message({
          message: "请先播放视频",
          type: "warning",
        });
      }
    },
    // 提交课签
    onSubmit() {
      this.addLabelLoading = true;
      if (this.labelFrom.isAdd) {
        var form = new FormData();
        form.append("file", this.imgSrcop);
        kqpostimg(form).then((res) => {
          this.labelFrom.screenshotUrl = res.data;
          addmark({
            chapterId: this.currentChapterId,
            userId: this.$store.getters.userId,
            labelInfo: this.labelFrom.labelInfo,
            labelTime: this.labelFrom.second,
            second: this.labelFrom.second,
            screenshotUrl: this.labelFrom.screenshotUrl,
          }).then((respond) => {
            this.addLabelLoading = false;
            this.closeAddLabel();
            this.$message.success("课签添加成功");
            this.labelTree.forEach((v) => {
              if (v.children) {
                v.children.forEach((i) => {
                  if (i.chapterId == this.currentChapterId && !i.isRequest) {
                    getLabelList({
                      userId: this.$store.getters.userId,
                      chapterId: i.chapterId,
                    }).then((res) => {
                      i.children = res.rows;
                    });
                  }
                });
              }
            });
          });
        });
      } else {
        updatemark({
          chapterId: this.uplateLabelForm.chapterId,
          id: this.uplateLabelForm.id,
          labelInfo: this.labelFrom.labelInfo,
          labelTime: this.uplateLabelForm.labelTime,
          screenshotUrl: this.uplateLabelForm.screenshotUrl,
          userId: this.uplateLabelForm.userId,
          // ...this.uplateLabelForm,
          // labelInfo:this.labelFrom.labelInfo
        }).then((res) => {
          this.addLabelLoading = false;
          this.closeAddLabel();
          this.$message.success("课签修改成功");
          this.labelTree.forEach((v) => {
            if (v.children) {
              v.children.forEach((i) => {
                if (i.chapterId == this.uplateLabelForm.chapterId && !i.isRequest) {
                  getLabelList({
                    userId: this.$store.getters.userId,
                    chapterId: i.chapterId,
                  }).then((res) => {
                    i.children = res.rows;
                  });
                }
              });
            }
          });
        });
      }
    },
    // 隐藏添加课签弹出框
    closeAddLabel() {
      this.isShowAddLable = false;
      this.labelFrom.labelInfo = "";
    },
    openAddLabel() {
      this.labelFrom.labelInfo = "";
      this.isShowAddLable = true;
      this.isShowLabelDetails = false;
    },
    // 获取书签列表
    handleGainLabel(item) {
      if (!item.loading) {
        if (item.isRequest) {
          item.loading = true;
          getLabelList({
            userId: this.$store.getters.userId,
            chapterId: item.chapterId,
          }).then((res) => {
            item.loading = false;
            item.children = res.rows;
            item.isRequest = false;
            item.isShow = true;
          });
        } else {
          item.isShow = !item.isShow;
        }
      }
    },
    // 课签详情
    handleLabelDetails(item, childItem, chapterIndex, sectionIndex) {
      this.labelDetails = item;
      this.chapterItem = childItem;
      // 课签对应的章index
      this.chapterIndex = chapterIndex;
      // 课签对应的节index
      this.sectionIndex = sectionIndex;
      this.isShowLabelDetails = true;
      this.isShowAddLable = false;
    },
    // 隐藏课签详情
    closeDetails() {
      this.isShowLabelDetails = false;
    },
    // 管理课签
    mangaeLabel() {
      this.isShowManage = !this.isShowManage;
    },
    // 立即跳转
    async onJumpNow(item) {
      await this.$refs.mtree.chilbtns(
        this.classStatus,
        this.chapterItem.chapterId,
        this.sectionIndex,
        this.chapterIndex,
        this.chapterItem.completion,
        this.chapterItem.label
      );
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.videomy.currentTime = item.labelTime;
          this.$refs.videomy.pause();
        }, 500);
      });
    },
    //视频截帧
    cutPicture() {
      var v = document.getElementById("videos");
      let canvas = document.getElementById("myCanvas");
      var ctx = canvas.getContext("2d");

      ctx.drawImage(v, 0, 0, 343, 200);
      this.imgSrcop = this.dataURLtoBlob(canvas.toDataURL("image/jpeg"));
    },
    //转化为文件流
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    handleTitleNav(i) {
      this.titleNav = i;
    },
    // 获取推荐课程
    getWebListCourse(params) {
      getWebListCourse(params)
        .then((res) => {
          if (res.code == 200) {
            this.recommendList = res.rows.filter((v) => this.$route.query.id != v.id);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlePath(item) {
      let rourl = this.$router.resolve({
        path: "/coursedetails",
        query: { id: item.id, professionId: item.professionId },
      });
      window.open(rourl.href);
    },
    handleLogin() {
      var that = this;
      this.$login({
        loginSuccess() {
          that.$router.push({
            path: "/redirect" + that.$route.fullPath,
          });
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coursedetails {
  width: 100%;
  min-height: 100vh;
  background-color: #f6f6f6;
  .details_bgvd {
    width: 100%;
    padding-bottom: 20px;
    background: #f7f8fa;
    .details_warp {
      // width: 1200px;
      margin: 0 auto;

      .vidall {
        // width: 800px;
        height: 445px;
        overflow: hidden;
        position: relative;
        // 课程封面
        .vid_cover {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          background-color: rgba(0, 0, 0, 0.3);
          .playicon {
            font-size: 75px;
            color: #ffffff;
            border-radius: 50%;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
        }

        // 返回Icon
        .arrleft {
          position: absolute;
          left: 0%;
          top: 5%;
          z-index: 10;
        }
        img {
          width: 100%;
          max-height: 500px;
        }
      }
      // 试看两分钟结束的icon
      .endwarp {
        width: 100%;
        height: 445px;
        background-size: 100% auto;
        background-position: center;
        background-repeat: no-repeat;
        .endicon {
          width: 100%;
          height: 100%;
          background: rgba($color: #292929, $alpha: 0.6);
          position: relative;
          text-align: center;
          // z-index: 1;
          .end_conts {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            p {
              color: #ffffff;
              font-size: 18px;
              letter-spacing: 2px;
            }
            .immediately {
              border: none;
              height: 35px;
              line-height: 10px;
              margin-top: 10px;
              background-color: #3964e6;
            }
          }
        }
        // 返回Icon
        .arrleft {
          position: absolute;
          left: 0%;
          top: 5%;
          z-index: 10;
        }
      }
      .deta_bread {
        margin-bottom: 20px;
        padding-top: 30px;
        ::v-deep {
          .el-breadcrumb__item {
            font-size: 16px;
          }
        }
        ::v-deep .el-breadcrumb__inner {
          color: #999999 !important;
        }
      }
      .course_details {
        position: relative;
        // padding: 0 60px;
        .inner {
          position: relative;
          display: flex;
        }
        .label_all {
          // position: absolute;
          // top: 0;
          // right: -400px;
          width: 400px;
          height: 500px;
          transition: all 0.3s;
          padding: 10px 0;
          background: #ffffff;
          border: 1px solid #eeeeee;
          border-radius: 6px 6px 0px 0px;
          padding-top: 0;
          ::v-deep {
            .el-scrollbar__wrap {
              overflow-x: hidden !important;
            }
            // .el-scrollbar__bar.is-horizontal {
            //   display: none;
            // }
          }
          &.label_all_active {
            right: 0;
          }
          .title_nav {
            display: flex;
            border-bottom: 1px solid #eeeeee;

            div {
              height: 60px;
              line-height: 60px;
              margin-left: 45px;
              font-weight: bold;
              color: #333333;
              font-size: 16px;
              cursor: pointer;
            }
            .title_nav_item {
              color: #1d4434;
              font-size: 18px;
            }
          }
          .course_lists {
            height: calc(100% - 60px);
            .course_list_box {
              padding-right: 20px;
            }
          }
          .shuqian_list {
            height: calc(100% - 60px);
            .loginLabeltxt {
              color: #1d4434;
              font-size: 20px;
              text-align: center;
              margin-top: 100px;
              text-decoration: underline;
              cursor: pointer;
            }
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 4px;
            padding-right: 20px;
            padding-top: 16px;
            padding-bottom: 10px;
            .line {
              width: 3px;
            }
            .other {
              display: inline-block;
              font-size: 12;
              overflow: hidden;
              // height: 14px;
              // width: 30px;
              // margin-left: 10px;
              // background-image: url('~@/assets/images/label_btn.png');
              text-align: center;
              line-height: 20px;
              cursor: pointer;
              color: #fff;
              margin-left: 26px;
              border-radius: 7px;
              &.self {
                background: #f8b551;
              }
              &.teacher {
                background: #1d4434;
              }
              &.teacher_active {
                background: #999999;
              }
              &.self_active {
                background: #999999;
              }
            }
          }
          .label_content {
            height: calc(100% - 115px);

            .label_title {
              padding: 0 10px 0 24px;
              margin-bottom: 8px;
              overflow: hidden;
              width: 100%;
              .label_header {
                display: block;
                width: 100%;
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #e5e5e5;
                font-size: 16px;
                color: #333333;
              }
              .label_sub_title {
                font-size: 14px;
                color: #999999;
                overflow: hidden;
                width: 100%;
                .label_header {
                  font-size: 16px;
                  color: #999999;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  cursor: pointer;
                  overflow: hidden;
                  padding-left: 20px;
                  font-family: Microsoft YaHei;
                }
                .label_item {
                  display: flex;
                  overflow: hidden;
                  width: 100%;
                  align-items: center;
                  margin-top: 10px;
                  // justify-content: space-between;
                  .left {
                    // flex: 1;
                    width: calc(100% - 74px);
                    align-items: center;
                    display: flex;
                    cursor: pointer;
                    .left_teacher {
                      overflow: hidden;
                      height: 20px;
                      width: 40px;
                      background-image: url("~@/assets/images/label_btn.png");
                      margin-right: 7px;
                      &.left_self {
                        background-position: -50px 0;
                      }
                    }
                    .icon {
                      width: 14px;
                      height: 14px;
                      background-image: url("~@/assets/images/icon.png");
                      margin-right: 10px;
                      overflow: hidden;
                    }
                    .txt {
                      flex: 1;
                    }
                  }
                  .right {
                    width: 74px;
                    .del {
                      margin-left: 12px;
                      color: #e60012;
                    }
                    span {
                      cursor: pointer;
                    }
                    .time {
                      color: #1d4434;
                    }
                  }
                }
              }
            }
          }
          .btn_box {
            display: flex;
            justify-content: space-around;
            padding: 0 10px;
            margin-top: 10px;
            position: relative;
            .operate_contenr {
              position: absolute;
              bottom: 50px;
              left: 0;
              width: 100%;
              .operate_item {
                background: #fff;
                position: absolute;
                bottom: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 90%;
                padding: 0 30px;
                border-radius: 10px 10px 0 0;
                box-shadow: 0px 0px 12px 2px rgba(85, 85, 85, 0.2);
                .header {
                  font-size: 18px;
                  font-weight: 800;
                  color: #222222;
                  padding: 18px;
                  text-align: center;
                  display: block;
                }
                .pause_time {
                  font-size: 16px;
                  color: #222222;
                  margin-bottom: 10px;
                  span {
                    color: #3964e6;
                  }
                }
                .footer {
                  text-align: center;
                  padding: 20px;
                }
                .label_header {
                  font-size: 16px;
                  margin-bottom: 10px;
                }
                .label_text {
                  font-size: 14px;
                  color: #333333;
                  padding-left: 20px;
                  margin-bottom: 10px;
                  max-height: 140px;
                  overflow-y: auto;
                }
                img {
                  display: block;
                  margin: 0 auto;
                  max-width: 100%;
                }
              }
            }
            .btn {
              width: 159px;
              height: 51px;
              border: 2px solid #999999;
              border-radius: 10px;
              line-height: 47px;
              text-align: center;
              transition: all 0.3s;
              font-size: 17px;
              font-weight: bold;
              color: #999999;
              &:hover {
                background: #1d4434;
                border-color: #1d4434;
                color: #fff;
              }
            }
          }
          .label_super {
            display: none;
          }
        }
        .label_box {
          position: absolute;
          top: 50%;
          right: 14px;
          transform: translateY(-50%);
          color: #bfbfbf;
          font-size: 12px;
          text-align: center;
          padding: 5px;
          cursor: pointer;
          .label {
            display: block;
            height: 21px;
            width: 19px;
            background-image: url("~@/assets/images/label.png");
            background-position: (-22px 0);
            margin: auto;
          }
          &.label_active,
          &:hover {
            color: #3964e6;
            .label {
              background-position: (0 0);
            }
          }
        }
      }
      // 视频
      .video_center {
        flex: 1;
        height: 439px;
        // margin: 20px auto;
        transition: all 0.3s;
        padding-right: 20px;
        video {
          width: 100%;
          height: 100%;
          // object-fit: fill;
          position: relative;
          left: 50%;
          transform: translate(-50%, 0);
          cursor: pointer;
        }
        // &.video_active{
        //   margin-right: 400px;
        // }
      }
      //标题
      .vid_title {
        // width: 1200px;
        margin: auto;
        margin-top: 15px;
        overflow: hidden;
        .title_txts {
          width: 85%;
          float: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          font-size: 28px;
          font-weight: 400;
          color: #242424;
        }
        .curnums {
          float: right;
          font-size: 18px;
          color: #242424;
        }
      }
      // 报名按钮
      .promptly_wap {
        // width: 1200px;
        // margin: 0 auto;
        // margin-top: 20px;
        // overflow: hidden;
        .promptly_btns {
          width: 130px;
          height: 40px;
          line-height: 15px;
          font-size: 18px;
          float: left;
        }
        span {
          font-size: 16px;
          font-weight: bold;
          // color: #ffffff;
          float: right;
          margin-top: 10px;
        }
      }
    }
  }
  // 二维码
  .img_code {
    width: 200px;
    height: 200px;

    margin: 0 auto;
    position: relative;
    .qrcode {
      width: 100%;
      height: 100%;
    }
    .zhezhao_code {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  // 试题的弹出框
  .examwarp {
    width: 90%;
    margin: 0 auto;
  }
  // 内容介绍
  .courwarp {
    width: 100%;
    background-color: #ffffff;
    overflow: hidden;
    padding-bottom: 80px;
    // 中间内容
    .courcenter {
      display: flex;
      // 左侧
      .couret_left {
        flex: 1;
        min-height: 500px;
        float: left;
        border-radius: 5px;
        background-color: #ffffff;
        padding-bottom: 30px;
        padding-right: 33px;
        padding-left: 34px;
      }
      // 头部
      .couret_heder {
        width: 100%;
        // border-right: 1px solid #999;

        .courheder_child {
          // width: 90%;
          margin: 0 auto;
          // 学习总进度
          .pane_tree {
            // width: 90%;
            margin-top: 20px;
            p {
              font-size: 16px;
              font-weight: bold;
              color: #999999;
              padding-bottom: 10px;
            }
          }
          ::v-deep {
            .el-tabs__item.is-active {
              color: #1d4434;
            }
            .el-tabs__item:hover {
              color: #1d4434;
            }
            .el-tabs__active-bar {
              background-color: #1d4434;
            }
          }
        }
        .cur_jieshao {
          font-size: 14px;
          font-weight: 400;
          color: #555555;
          line-height: 1.7;
          text-indent: 20px;
          background: #f5f8f4;
          padding: 20px;
          border-radius: 10px;
        }
      }
      // 右侧
      .couret_rig {
        width: 300px;
        min-height: 450px;
        float: right;
        border-radius: 5px;
        box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        .couret_heder_rig {
          width: 100%;
          height: 54px;
          border-bottom: 2px solid #eeeeee;
          line-height: 54px;
          p {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            margin-left: 30px;
          }
        }
        // 讲师介绍
        .teach_detail {
          width: 100%;
          overflow: hidden;
          .teach_avimg {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin: 20px auto;
          }
          .teach_names {
            width: 100%;
            text-align: center;
            font-weight: bold;
            color: #333333;
          }
          .tech_contxts {
            width: 90%;
            margin: 20px auto;
            font-size: 14px;
            font-weight: 500;
            color: #333333;
            line-height: 1.7;
            text-indent: 15px;
          }
        }
      }
      // 右侧
      .couret_right {
        width: 480px;
        border: 1px solid #eeeeee;
        margin-top: 20px;
        .tuijian_title {
          color: #1d4434;
          padding: 20px;
          border-bottom: 1px solid #eeeeee;
          font-weight: bold;
        }
        .recommend_list {
          margin-bottom: 10px;
          padding: 30px 20px;
          .unllTyoe {
            text-align: center;
            margin: 100px 0;
          }
        }
        .recommend_item {
          display: flex;
          margin-bottom: 30px;
          cursor: pointer;
          .img_box {
            height: 110px;
            width: 180px;
            padding: 5px;
            border-radius: 8px;
            border: 1px solid #eeeeee;
          }
          .right_text {
            flex: 1;
            padding-left: 10px;
            .recommend_title {
              font-size: 16px;
              color: #333333;
              padding: 9px 0 10px 0;
            }
            .recommend_synop {
              font-size: 14px;
              color: #999999;
              height: 61px;
              overflow: hidden;
              word-break: break-all;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
  .overflow_sellip {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
